import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FactoringOperationsService } from '../../files-clients/service/factoring-operations.service';
import { FactoringCalculationRequest, FactoringCalculationResponse, FactoringCalculationResultViewModel, FactoringCalculationViewModel } from '../../files-clients/interface/invoice-operation.interface';

@Component({
  selector: 'app-invoice-operation-calculation-form',
  templateUrl: './invoice-operation-calculation-form.component.html',
  styleUrls: ['./invoice-operation-calculation-form.component.scss']
})
export class InvoiceOperationCalculationFormComponent implements OnInit{

  @Input() invoiceOperationCurrent: FactoringCalculationViewModel;
  @Output() factoringCalculationResult = new EventEmitter<FactoringCalculationResultViewModel | null>;

  /**
   * Calculo de factoring entregado por el servicio
   */
  public factoringCalculation: FactoringCalculationResponse | null = null;
  public isCalculationRequired: boolean = true;

  public formGroup: FormGroup;
  constructor(private factoringService: FactoringOperationsService,
    private fb: FormBuilder
  ){
    this.formGroup = new FormGroup({
      rate: new FormControl<number |null>(0,
        [Validators.required,
        Validators.min(1),
        Validators.max(99)]
      ),
      operationalCost: new FormControl<number | null>(0,
        [Validators.required, Validators.min(1)]
      ),
      plazo: new FormControl<number | null>(0, [Validators.required, Validators.min(1)]),
      downPaymentPercentage: new FormControl<number | null>(0,
        [Validators.required, Validators.min(1), Validators.max(100)]
      )
    })
  }

  ngOnInit(): void {
    if(this.invoiceOperationCurrent) {
      const {downPaymentPercentage, plazo, rate, operationCost} = this.invoiceOperationCurrent;
      this.formGroup.patchValue({
        downPaymentPercentage: downPaymentPercentage,
        operationalCost: operationCost || null,
        rate: rate || null,
        plazo: plazo || null
      });
    }
  }

  get controls() {
    return this.formGroup.controls;
  }

  isValidToCalculate(): boolean {
    const hasRate = this.formGroup.controls['rate'].valid;
    const hasPlazo = this.formGroup.controls['plazo'].valid
    const hasOperationCost = this.formGroup.controls['operationalCost'].valid;
    const hasDownPayment = this.formGroup.controls['downPaymentPercentage'].valid;
    return hasRate && hasPlazo && hasOperationCost && hasDownPayment;
  }

  calculateOperation() {
    const {plazo, rate, operationalCost, downPaymentPercentage } = this.formGroup.value;
    const calculationRequest: FactoringCalculationRequest = {
      invoiceId: this.invoiceOperationCurrent.invoiceId.toString(),
      plazo: plazo,
      rate: rate,
      downPaymentPercentage: downPaymentPercentage,
      operationCost: operationalCost
    };
    this.factoringService.calculateInvoiceOperation(calculationRequest)
    .subscribe({
      next: (response) => {
        this.factoringCalculation = response.value;
        this.isCalculationRequired = false;
        this.submit();
      },
      error: (err) => {
        this.isCalculationRequired = true;
        this.factoringCalculationResult.emit(null);
      }
    });
  }

  changeCalculationInput(){
    if(this.isCalculationRequired) return;
    this.factoringCalculation = null;
    this.isCalculationRequired = true;
    this.factoringCalculationResult.emit(null);
  }

  submit(){
    const {plazo, rate, operationalCost, downPaymentPercentage } = this.formGroup.value;
    const {
      transferAmount,
      allInRate,
      operationalCostTax,
      priceDifference,
      financedAmount,
    } = this.factoringCalculation;
    const calculationResult: FactoringCalculationResultViewModel = {
      plazo: plazo,
      rate: rate,
      downPaymentPercentage: downPaymentPercentage,
      operationalCost: operationalCost,
      financedAmount: financedAmount,
      priceDifference: priceDifference,
      operationalCostTax: operationalCostTax,
      allInRate: allInRate,
      transferAmount: transferAmount
    };
    this.factoringCalculationResult.emit(calculationResult);
  }
}
